/*
*
* File JS per la Single Room
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroImage from 'imComponents/hero-image/hero-image';

import blockGalleryOffScreen from 'components/gallery-off-screen/gallery-off-screen';

import blockTextImg from 'components/block-text-img/block-text-img';

import blockOffers from 'components/block-offers/block-offers';

import modal from 'imComponents/modal/modal';

import blockBannerSimple from 'components/block-banner-simple/block-banner-simple';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './single-room.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

blockGalleryOffScreen();

blockOffers();

modal();

//--------------------------------------------------------------------//